export default {"src":"/blogs/_next/static/media/ellipsis.e0afb01c.svg","height":15,"width":4,"blurWidth":0,"blurHeight":0};